import React from 'react';
import { Icon } from 'ui';
import { TYPES } from 'constants/config';
import CertificationBadge from 'components/CertificationBadge';

const TypeIcon = ({ type, badge }) => {
  if (badge && badge.id) {
    return (
      <div className="mr-10 d-f">
        <CertificationBadge
          iconName={badge.iconName || badge.icon_name}
          width={22}
          height={29}
          foregroundColor={badge.foregroundColor || badge.foreground_color}
          backgroundColor={badge.backgroundColor || badge.background_color}
          image={badge.image}
        />
      </div>
    );
  }
  if (type === TYPES.PATH) {
    return <Icon name="path" className="PathContent-icon" />;
  }
  return null;
};

const Title = ({
  title,
  urls = {},
  parent = {},
  showLessonOverviewLink,
  type,
  badge,
}) => (
  <div className="PathContent-title d-f ai-c">
    {parent.title && <span>{parent.title}</span>}
    {parent.title && (
      <Icon
        name="chevron_right"
        className="fz-sm c-brand-gray-light ml-8 mr-8"
      />
    )}
    <TypeIcon type={type} badge={badge} />
    {showLessonOverviewLink && (
      <a
        href={urls.overview}
        target="_blank"
        rel="noreferrer noopener"
        className="u-linkBtn"
      >
        <span className="text-wrap">{title}</span>
      </a>
    )}
    {!showLessonOverviewLink && <span>{title}</span>}
  </div>
);

const ContentTitle = ({
  title,
  urls,
  type,
  parent,
  showLessonOverviewLink,
  badge,
}) => {
  return (
    <div className="f-smooth d-f ai-c">
      <Title
        type={type}
        badge={badge}
        urls={urls}
        title={title}
        parent={parent}
        showLessonOverviewLink={showLessonOverviewLink}
      />
    </div>
  );
};

export default ContentTitle;
